// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3v0D-","col":"CardReaderDesc_col__2aNxh","label":"CardReaderDesc_label__149-T"};